const TYPE_VALUES = {
  withdrawals: "withdrawals",
  transactions: "transactions",
};

export { TYPE_VALUES };
